export default {"src":"/_next/static/media/news.f8fa4d2f.svg","height":36,"width":56,"blurWidth":0,"blurHeight":0};